"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdUnit = void 0;
class AdUnit {
    equals(adUnit) {
        return this.displayName === adUnit.displayName;
    }
}
exports.AdUnit = AdUnit;
//# sourceMappingURL=ad-unit.js.map